import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";

const State = () => {


  const [showForm, setShowForm] = useState(false);

  const [address, setAddress] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [cities, setCities] = useState([]);
  const [pincodes, setPincodes] = useState([]);

  const [filteredAddress, setFilteredAddress] = useState([]);
  const [showStateModal, setShowStateModal] = useState(false);
  const [newStateName, setNewStateName] = useState("");

  const [showCityModal, setShowCityModal] = useState(false);
  const [newCityName, setNewCityName] = useState("");

  const [showPincodeModal, setShowPincodeModal] = useState(false);
  const [newPincode, setNewPincode] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [stateOptions, setStateOptions] = useState([]);

  const [form, setForm] = useState({
    state: '',
    city: '',
    region: '',
    pincode: ''
  })

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const [editingCompanyId, setEditingCompanyId] = useState(null);


  const handleAddClick = () => {
    setShowForm(true);
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  


  const handleSubmit = async (e) => {
    e.preventDefault();


    if (isEditMode) {
      const sendData = new FormData();

      sendData.append("state", form.state);
      sendData.append("city", form.city);
      sendData.append("region", form.region);
      sendData.append("pincode", form.pincode);


      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-state/${form.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        handleUpdateAddress(res.data);

        fecthDetail();
        showToast('Address updated successfully!', 'success');
        setShowForm(false);
        setForm({
          state: '',
          city: '',
          region: '',
          pincode: ''
        })
      } catch (err) {
        showToast('Fail to update address!', 'danger');

        console.error("❌ Error:", err.response?.data || err.message);
      }

    } else {
      const sendData = new FormData();

      sendData.append("state", form.state);
      sendData.append("city", form.city);
      sendData.append("region", form.region);
      sendData.append("pincode", form.pincode);


      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-state",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );

        fecthDetail();
        fetchDataByState();
        handleSearch();
        showToast('Address Added successfully!', 'success');
        setShowForm(false);
        setForm({
          state: '',
          city: '',
          region: '',
          pincode: ''
        })
      } catch (err) {
        const backendMsg = err.response?.data?.error;

        console.error("❌ Error:", err.response?.data || err.message);
        showToast(backendMsg, 'danger');
      }
    }
  };

  const fecthDetail = async () => {

    try {
      const resParty = await axios.get('https://api.skyguard.group/api/fetch-state');
      setAddress(resParty.data.result);
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {

    fecthDetail();
  }, []);


  const handleEdit = (form) => {

    if (form.city && !cities.includes(form.city)) {
      setCities(prev => [...prev, form.city]);
    }

    // Add pincode to pincodes list if it doesn't exist
    if (form.pincode && !pincodes.includes(form.pincode)) {
      setPincodes(prev => [...prev, form.pincode]);
    }

    setForm({
      id: form.id || '',
      state: form.state || '',
      city: form.city || '',
      region: form.region || '',
      pincode: form.pincode || ''
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


  const fetchStates = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/get-states");
      // Assuming your backend returns an array of state names
      setStateOptions(res.data);
    
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  useEffect(() => {

    fetchStates();
  }, []);



  const fetchDataByState = async (state) => {
    if (!state) return;

    try {
      const response = await axios.get(
        `https://api.skyguard.group/api/get-state-data?state=${encodeURIComponent(state)}`
      );

      const data = response.data;


      if (!data || data.length === 0) {
        setCities([]);
        setPincodes([]);
        showToast("No city available for this state", "warning");  // <-- show warning message
        return;
      }

      // const cityList = response.data.map(item => item.city);
      const cityList = [...new Set(data.map(item => item.city))];
      const pincodeList = response.data.map(item => item.pincode);

      setCities(cityList);
      setPincodes(pincodeList);

    } catch (error) {
      console.error("Error fetching cities by state:", error);
    }
  };



  const handleSearch = () => {
    let result = address;

    // Filter by state if selected
    if (form.state) {
      result = result.filter(item => item.state === form.state);
    }

    // Filter by city if selected
    if (form.city) {
      result = result.filter(item => item.city === form.city);
    }

    // Filter by pincode if selected
    if (form.pincode) {
      result = result.filter(item => item.pincode === form.pincode);
    }

    // Update filteredAddress
    setFilteredAddress(result);

    // Show warning if no records found
    if (result.length === 0) {
      showToast("No records found for the selected filters", "warning");
    }
  };



  useEffect(() => {
    if (address.length === 0) return;


    const latestTen = [...address].reverse().slice(0, 10);

    setFilteredAddress(latestTen);
  }, [address]);

  const handleUpdateAddress = (updatedItem) => {
    // Update the address array
    const updatedAddress = address.map(item =>
      item.id === updatedItem.id ? updatedItem : item
    );

    // Move the updated item to the start of the array
    const reorderedAddress = [
      updatedItem,
      ...updatedAddress.filter(item => item.id !== updatedItem.id)
    ];

    setAddress(reorderedAddress);

    // Update filteredAddress to show latest 10
    setFilteredAddress(reorderedAddress.slice(0, 10));
  };




const getTableSearchData = () => {
  const term = searchTerm.toLowerCase();

  return filteredAddress.filter((tt) => {
    return (
      (tt.state && tt.state.toLowerCase().includes(term)) ||
      (tt.city && tt.city.toLowerCase().includes(term)) ||
      (tt.pincode && tt.pincode.toString().toLowerCase().includes(term)) ||
      (tt.region && tt.region.toString().toLowerCase().includes(term))
    );
  });
};

  return (
    <>
      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>Master of State</h3>


<div className="mb-3 row gx-3 gy-2 align-items-end">

  {/* LEFT SIDE CONTROLS */}
  <div className="col-12 col-md d-flex flex-wrap align-items-end">
    {/* Search Bar */}
    <div className="col-12 col-md-3 mb-2 pe-md-2">
      <input
        className="form-control w-100"
        list="datalistOptions"
        placeholder="Search by State, City, Pincode, Region ..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>

    {/* State Dropdown */}
    <div className="col-12 col-md-2 mb-2 pe-md-2">
      <select
        className="form-select"
        name="state"
        value={form.state}
        onChange={(e) => {
          const selectedState = e.target.value;
          setForm({ ...form, state: selectedState });
          fetchDataByState(selectedState);
        }}
      >
        <option value="">Select State</option>
        {stateOptions.map((state) => (
          <option key={state} value={state}>{state}</option>
        ))}
      </select>
    </div>

    {/* City Dropdown */}
    <div className="col-12 col-md-2 mb-2 pe-md-2">
      <select
        className="form-select"
        value={form.city}
        onChange={(e) => setForm({ ...form, city: e.target.value })}
      >
        <option value="">Select City</option>
        {cities.map((city, index) => (
          <option key={index} value={city}>{city}</option>
        ))}
      </select>
    </div>

    {/* Search Button */}
    <div className="col-12 col-md-2  mb-2">
      <button className="btn btn-primary px-3" onClick={handleSearch}>
        Search
      </button>
    </div>
  </div>

  {/* RIGHT SIDE: Add Button */}
  <div className="col-12 col-md-auto d-flex justify-content-end align-items-end">
    <button className="btn btn-success">
      <AiOutlinePlusCircle size={20} onClick={handleAddClick} /> Add
    </button>
  </div>

</div>



          {showForm && (


            <div className='card p-3 mb-3  w-75 mx-auto'>
              <form onSubmit={handleSubmit} >



                <hr />

                <div className='row g-3'>



                  <div className="col-md-6">
                    <label>State</label>
                    <select
                      className="form-select"
                      name="state"
                      value={form.state}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value === "__add_new__") {
                          setShowStateModal(true); // open modal
                        } else {
                          setForm({ ...form, state: value });
                          fetchDataByState(value); // fetch cities for selected state
                        }
                      }}
                      required
                    >
                      <option value="">Select State</option>
                      {stateOptions.map((state) => (
                        <option key={state} value={state}>{state}</option>
                      ))}
                      <option value="__add_new__">➕ Add New State</option>
                    </select>
                  </div>


                  {showStateModal && (
                    <div className="modal show d-block" tabIndex="-1">
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Add New State</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setShowStateModal(false)}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter state name"
                              value={newStateName}
                              onChange={(e) => setNewStateName(e.target.value)}
                            />
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => {
                                setNewStateName("");
                                setShowStateModal(false);
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => {
                                if (!newStateName.trim()) return;

                                // ✅ Add new state to stateOptions
                                setStateOptions([...stateOptions, newStateName]);

                                // ✅ Set newly added state as selected
                                setForm({ ...form, state: newStateName });

                                // ✅ Fetch cities for new state if needed
                                fetchDataByState(newStateName);

                                // reset + close modal
                                setNewStateName("");
                                setShowStateModal(false);
                              }}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}



                  <div className="col-md-6">
                    <label htmlFor="city" className="form-label fw-medium">City</label>
                    <select
                      className="form-select"
                      value={form.city}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value === "__add_new__") {
                          setShowCityModal(true); // open modal
                        } else {
                          setForm({ ...form, city: value });
                        }
                      }}
                    >
                      <option value="">Select City</option>
                      {cities.map((city, index) => (
                        <option key={index} value={city}>{city}</option>
                      ))}
                      <option value="__add_new__">➕ Add New City</option>
                    </select>
                  </div>


                  {showCityModal && (
                    <div className="modal show d-block" tabIndex="-1">
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Add New City</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setShowCityModal(false)}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter city name"
                              value={newCityName}
                              onChange={(e) => setNewCityName(e.target.value)}
                            />
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => {
                                setNewCityName("");
                                setShowCityModal(false);
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => {
                                if (!newCityName.trim()) return;

                                // Add new city to cities array
                                setCities([...cities, newCityName]);

                                // Set the newly added city as selected
                                setForm({ ...form, city: newCityName });

                                // Reset input and close modal
                                setNewCityName("");
                                setShowCityModal(false);
                              }}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}



                  <div className="col-md-6">
                    <label htmlFor="pincode" className="form-label fw-medium">Pincode</label>
                    <select
                      className="form-select"
                      value={form.pincode}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value === "__add_new__") {
                          setShowPincodeModal(true); // open modal
                        } else {
                          setForm({ ...form, pincode: value });
                        }
                      }}
                    >
                      <option value="">Select Pincode</option>
                      {pincodes.map((pin, index) => (
                        <option key={index} value={pin}>{pin}</option>
                      ))}
                      <option value="__add_new__">➕ Add New Pincode</option>
                    </select>
                  </div>

                  {showPincodeModal && (
                    <div className="modal show d-block" tabIndex="-1">
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Add New Pincode</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setShowPincodeModal(false)}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter pincode"
                              value={newPincode}
                              onChange={(e) => setNewPincode(e.target.value)}
                            />
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => {
                                setNewPincode("");
                                setShowPincodeModal(false);
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => {
                                if (!newPincode.trim()) return;

                                // Add new pincode to array
                                setPincodes([...pincodes, newPincode]);

                                // Set as selected
                                setForm({ ...form, pincode: newPincode });

                                // Reset input and close modal
                                setNewPincode("");
                                setShowPincodeModal(false);
                              }}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}


                  <div className="col-md-6">
                    <label htmlFor='middle' className="form-label fw-medium" > Region</label>
                    <input type="text" className="form-control" name="region" placeholder="Enter here..."
                      value={form.region}
                      onChange={handleInputChange}

                    />
                  </div>

                  <div className='gap-2 d-flex justify-content-center mt-4'>

                    <button type="submit" className='btn btn-success w-10'>
                      {isEditMode ? "Update" : "Save"}
                    </button>
                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                      setShowForm(false);
                      setIsEditMode(false);
                      setForm({
                        state: '',
                        city: '',
                        region: '',
                        pincode: ''
                      })
                    }}>
                      Cancel
                    </button>
                  </div>

                </div>
              </form>
            </div>
          )}



          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
                      
                  <th scope='col'>SN</th>
                     <th scope='col'>Action</th>
                  <th scope='col'>State</th>
                  <th scope='col'>City</th>

                  <th scope='col'>Pincode</th>
                  <th scope='col'>Region</th>

           
                </tr>
              </thead>
              <tbody>


                {getTableSearchData().map((acc, idx) => (
                  <tr key={idx}>
                      <td>{idx + 1}</td>
                       <td>
                      <button className="btn btn-success" onClick={() => handleEdit(acc)}>
                        <CiEdit size={20} />
                      </button>
                    </td>
                  
                    <td>{acc.state}</td>
                    <td>{acc.city}</td>

                    <td>{acc.pincode}</td>
                    <td>{acc.region}</td>
                 
                  </tr>
                ))}

              </tbody>
            </table>
          </div>




        </div>
      </div>
    </>
  )
}

export default State